var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',[_c('i-col',{attrs:{"span":"24"}},[_c('div',{staticStyle:{"width":"100%"},attrs:{"id":"home_page_map"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }